import React from "react";

import { useAppSelector } from "../../../app/store";
import {
  isAccountDetailsEnabled,
  isSanctionsAndDisbursementEnabled,
} from "../../configs/logic/Slice";
import WorkbenchTabs, { WorkbenchTab } from "./WorkbenchTabs";
import AccountDetailsTab from "../../accountDetails/components/AccountDetailsTab";
import DisbursementsContainer from "../../disbursements/components/DisbursementsContainer";
import SanctionEventsContainer from "../../sanctionEvents/components/SanctionEventsContainer";
import InvestigationEntitiesContainer from "./InvestigationEntitiesContainer";

const AccountDetailsPage: React.FC = () => {
  const accountDetailsEnabled = useAppSelector(isAccountDetailsEnabled);
  const sanctionsAndDisbursementEnabled = useAppSelector(
    isSanctionsAndDisbursementEnabled,
  );

  const tabs: WorkbenchTab[] = [];

  if (accountDetailsEnabled) {
    tabs.push({
      key: "account-details",
      label: "Account Details",
      content: <AccountDetailsTab />,
    });
  }

  if (sanctionsAndDisbursementEnabled) {
    tabs.push({
      key: "sanctions-disbursements",
      label: "Sanctions & Disbursements",
      content: (
        <>
          <SanctionEventsContainer />
          <DisbursementsContainer />
        </>
      ),
    });
  }

  return (
    <div>
      <InvestigationEntitiesContainer />
      <WorkbenchTabs
        tabs={tabs}
        contentCardClassName="border border-gray-100 shadow-overviewCard rounded-b-xl bg-white overflow-hidden"
      />
    </div>
  );
};

export default AccountDetailsPage;
